import { createContext, useContext } from "react";

export const DashboardDataContext = createContext({
  queryData: {},
  globalState: {},
  setGlobalState: () => {},
  effectiveCss: "",
  effectiveTemplate: "",
  isEditing: false,
  localCss: "",
  localTemplate: "",
  localQuery: "",
  toggleEdit: () => {},
  reset: () => {},
  setLocalCss: () => {},
  setLocalTemplate: () => {},
  setLocalQuery: () => {},
  activeTab: "template",
  setActiveTab: () => {},
  componentContent: new Map(),
  setComponentContent: () => {},
  setQueryData: () => {},
});

export const useDashboardData = () => useContext(DashboardDataContext);
